import { Footer, Navbar, AuthWall } from '@components';

import Box from '@mui/material/Box';
import classnames from 'classnames';
import { useAppContext } from '@containers';
import { Button, Fab } from '@mui/material';
import { useTranslation } from 'next-i18next';
import RoomServiceOutlinedIcon from '@mui/icons-material/RoomServiceOutlined';
import { useScroll, motion } from 'motion/react';
import { useEffect, useRef, useState } from 'react';
function DefaultLayout({
  children,
  header,
  className,
  showBookingCta = true,
  ctaUrl = null,
  enableAuthWall = false,
}) {
  const { user } = useAppContext();
  const { t } = useTranslation();
  const mainRef = useRef(null);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const { scrollY } = useScroll();

  //? workaround to keep fab button and "hidden" footer
  useEffect(() => {
    // checks if bottom of <main> is reached
    return scrollY.on('change', (latestScroll) => {
      const mainElement = mainRef.current;
      if (!mainElement) return;

      // calculates the bottom position of <main> relative to the top of the document
      const mainTop = mainElement.offsetTop;
      const mainHeight = mainElement.offsetHeight;
      const mainBottom = mainTop + mainHeight;

      // Current viewport bottom (relative to the document)
      const viewportBottom = latestScroll + window.innerHeight;

      // If viewport bottom has reached or surpassed the main bottom, we've "hit" the bottom.
      const atBottom = viewportBottom >= mainBottom;
      setIsAtBottom(atBottom);
    });
  }, [scrollY]);

  return (
    <>
      <div
        id="default-layout"
        className={classnames(
          'layout default-layout',
          'min-h-screen',
          'relative overflow-x-hidden',
        )}
      >
        <Navbar />
        {header && header}

        <main
          ref={mainRef}
          className={classnames(
            className,
            'relative z-50 mb-[40rem] bg-neutral xl:mb-[40rem] px-0 md:px-0 spacing-y-20',
          )}
        >
          {!enableAuthWall && children}
          {enableAuthWall && user?.logged && children}
          {enableAuthWall && !user?.logged && <AuthWall />}

          {showBookingCta && (
            <motion.div
              className={classnames(
                'z-50 right-1 md:right-2',
                isAtBottom ? 'absolute bottom-1' : 'fixed bottom-8',
              )}
              animate={{
                y: isAtBottom ? 0 : -20,
                opacity: 1,
              }}
              transition={{
                type: 'spring',
                stiffness: 150,
                damping: 20,
              }}
            >
              <Button
                variant="contained"
                className="bg-secondary hover:bg-secondary-600 space-x-1"
                href={ctaUrl ? ctaUrl : '/booking'}
              >
                <RoomServiceOutlinedIcon />
                <p className="uppercase leading-none font-medium">
                  {t('buttons.book_now')}!
                </p>
              </Button>
            </motion.div>
          )}
        </main>
        <Footer />
      </div>
    </>
  );
}

export default DefaultLayout;
